module.exports = __webpack_public_path__ + "static/media/phone32x.1305d3b3.png";